import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";

let createColumn=require('../../../../../js/formBuilder/sfAnalytics').CreateColumn;

export class ColumnDialog extends DynamicDialog<ColumnDialogProps,ColumnDialogState> {
    static defaultProps: Partial<ColumnDialogProps> = {};

    constructor(props: ColumnDialogProps) {
        super(props);
        this.state = {
            IsOpen:true
        };
    }



    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Column Configuration',
            IsOpen:this.state.IsOpen,
            Icon:<FontAwesomeIcon icon={faCog}/>,
            EnableApply:true,
            EnableCancel:false,
            OnApply:()=>{this.SendResult(true);this.setState({IsOpen:false})}
        };
    }

    SubRenderer(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div>
                {this.props.Column.map(x=>
                    createColumn(x)!=null&&
                    <div key={x.Id} style={{margin:'10px 0',cursor:'pointer'}}>
                        <input id={'ch'+x.Id} type={'checkbox'} onChange={ch=>{x._Selected=ch.target.checked;this.forceUpdate();}} checked={x._Selected}/>
                        <label htmlFor={'ch'+x.Id} style={{marginLeft:5}}>{x.Label}</label>
                    </div>
                )}
            </div>
        );
    }
}



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ColumnDialogProps {
    Column:any[];
}

interface ColumnDialogState extends DynamicDialogState{

}

//#endregion "My Region"